$('.product__info-main').on('click', '#bcpo .bcpo-front-button-label', function() {
  var current = $(this);
  var currentInput = current.parent().find('input');
  if (current.closest('.selector-wrapper').find('.customize-switch-wrapper').length > 0) {
    // 带定制项
    if (currentInput.attr('value').toLowerCase() != 'customize') {
      // 未选中定制
      if (product.metafields.custom.size_range != null) {
        const list = coverageSize(currentInput.attr('value'));
        $('.coverage_size .coverage_width').text(list[0]);
        $('.coverage_size .coverage_length').text(list[1]);
      }
    } else {
      // 选中定制
      $('#bcpo .bcpo-default:has(select[name^="properties["]) select').eq(0).change();
    }
  }
});

$('.product__info-main').on('click', '#bcpo .single-option-selector label', function() {
  var current = $(this);
  var currentInput = current.parent().find('input');
  var currentOption = current.closest('.single-option-selector');

  var inputCheckedList = {
    option1: $('.single-option-selector[data-option="option1"] input:checked').val() || null,
    option2: $('.single-option-selector[data-option="option2"] input:checked').val() || null,
    option3: $('.single-option-selector[data-option="option3"] input:checked').val() || null,
    [currentOption.attr('data-option')]: currentInput.val()
  }

  const type = product.variants.filter(item => {
    return item.option1 == inputCheckedList.option1 && item.option2 == inputCheckedList.option2 && item.option3 == inputCheckedList.option3 && item.issale;
  });

  // 角标统一由 syncVariantSaleBadge() 维护（见下方 MutationObserver），这里仅作即时反馈
  syncVariantSaleBadge();
})

$('.product__info-main').on('change', '#bcpo select[name^="properties["]', function() {
  var selectArr = [];
  $.each($('#bcpo select[name^="properties["]'), (i, item) => {
    selectArr.push($(item).val() || 0);
  });
  if (product.metafields.custom.size_range != null) {
    const list = coverageSize(selectArr.join('*'));
    $('.coverage_size .coverage_width').text(list[0]);
    $('.coverage_size .coverage_length').text(list[1]);
  }
  // 属性下拉变化也会切换变体，同步折扣角标
  syncVariantSaleBadge();
})

// ========== 折扣率角标跟随当前变体 ==========
// 修复：切换 Customize 选项时角标不随价格更新。
// 从隐藏域 input[name="id"] 读当前变体，算法与详情页服务端 Liquid 对齐：
// ceil((compare_at_price - price) * 100 / compare_at_price)。
// 用 MutationObserver 监听价格区块，任何路径（Size 点击 / Customize 切换 /
// 属性下拉 / 主题变体重渲染）导致价格 DOM 变化后都会自动同步。
function getCurrentProductVariant() {
  if (typeof product === 'undefined' || !product.variants) return null;
  var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], .product-form input[name="id"]');
  if (!idInput) return null;
  var id = parseInt(idInput.value, 10);
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].id === id) return product.variants[i];
  }
  return null;
}

function variantSaleBadgeHtml(variant) {
  if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return '';
  var percent = Math.ceil((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
  return '<span class="badge badge--sale variantIssale" aria-hidden="true"><span>-' + percent + '%</span></span>';
}

var variantBadgeObserver = null;

function syncVariantSaleBadge() {
  var box = document.querySelector('.product__info-main .priceBox');
  if (!box) return;
  var $price = $(box).find('.price.price--product');
  var $badge = $(box).find('.product__badge');
  if (!$price.length || !$badge.length) return;

  var html = variantSaleBadgeHtml(getCurrentProductVariant());
  var hasSale = html !== '';
  var synced = $badge.attr('data-synced-badge') || '';
  if (synced === html && $price.hasClass('price--on-sale') === hasSale) return;

  // 先断开观察再写入，避免自身修改触发回调造成循环
  if (variantBadgeObserver) variantBadgeObserver.disconnect();
  $badge.attr('data-synced-badge', html).html(html);
  $price.toggleClass('price--on-sale', hasSale);
  variantBadgeObserver.observe(box, { childList: true, characterData: true, subtree: true });
}

function initVariantBadgeSync() {
  var box = document.querySelector('.product__info-main .priceBox');
  if (!box) return;
  variantBadgeObserver = new MutationObserver(function () {
    syncVariantSaleBadge();
  });
  variantBadgeObserver.observe(box, { childList: true, characterData: true, subtree: true });
  syncVariantSaleBadge();
}

initVariantBadgeSync();

// 创建观察器实例
const bcpoObserver = new MutationObserver(mutations => {
  const titleArr = product.title.split(' ');
  const productTitle = titleArr[0] + titleArr[1];
  const targetElement = document.querySelector('#bcpo');
  if (targetElement) {
    bcpoObserver.disconnect();
    console.log('Bcpo Load');
    var str = [];
    str.push(`<div class="customize-switch-wrapper">`);
    if (product) {
      str.push(`<p class="tips">${ product.metafields.custom.product_tips ? product.metafields.custom.product_tips[0] : '' }</p>`);
    }
    str.push(`<div class="customize-switch-btn active" data-customize-switch-btn="size" click-data="${productTitle}-click_Size">Size</div>`);
    str.push(`<div class="customize-switch-btn" data-customize-switch-btn="customize" click-data="${productTitle}-click_Customize">Customize</div>`);
    str.push(`</div>`);

    $('.bcpo-label:has(~.single-option-selector:has(.bcpo-front-button-option[value="customize" i]))').after(str.join(''));

    // 把尺寸提示加到 #bcpo 最后
    if (product && product.metafields.custom.size_tip) {
      $(targetElement).append(`<div class="tips isCustomize">${ product.metafields.custom.size_tip }</div>`);
    }

    $.each(product.variants, function(i, item) {
      if (item.issale) {
        $(`input[value="${item.option1}"]`).parent().attr('issale', true);
        $(`input[value="${item.option2}"]`).parent().attr('issale', true);
        $(`input[value="${item.option3}"]`).parent().attr('issale', true);
      }
    })

    // ========== inch-input输入框逻辑 ==========
    // $('#bcpo .bcpo-default').each(function(){
    //   const $wrap = $(this);
    //   const $select = $wrap.find('select[name^="properties["]');
    //   if(!$select.length) return;

    //   // 防止重复创建输入框
    //   if ($wrap.find('.inch-input-group').length > 0) return;

    //   const $inputGroup = $(`
    //     <div class="inch-input-group">
    //       <input class="inch-input" type="number" min="45" max="360" value="${$select.val()}">
    //     </div>
    //   `);
    //   $select.after($inputGroup);
    //   const $input = $inputGroup.find('.inch-input');

    //   // 校验所有inch-input，统一控制提交按钮状态
    //   function checkAllInputValid() {
    //     let allValid = true;
    //     $('#bcpo .inch-input').each(function(){
    //       const val = $(this).val();
    //       const num = Number(val);
    //       if(isNaN(num) || num < 45 || num > 360){
    //         allValid = false;
    //       }
    //     });
    //     if(allValid){
    //       $('.product-form__submit').removeClass('disabled');
    //     }else{
    //       $('.product-form__submit').addClass('disabled');
    //     }
    //   }

    //   // select改变 → input同步更新 + 校验
    //   $select.on('change', function(){
    //     const val = $(this).val();
    //     $input.val(val);
    //     const num = Number(val);
    //     if(num >= 45 && num <= 360){
    //       $input.removeClass('input-error');
    //     }else{
    //       $input.addClass('input-error');
    //     }
    //     checkAllInputValid();
    //   });

    //   // input输入 → 同步select + 校验
    //   $input.on('input', function(){
    //     let num = Number($(this).val());
    //     if(isNaN(num) || num < 45 || num > 360){
    //       $(this).addClass('input-error');
    //     }else{
    //       $(this).removeClass('input-error');
    //       $select.find(`option[value="${num}"]`).prop('selected', true);
    //       $select.trigger('change');
    //     }
    //     checkAllInputValid();
    //   });

    //   // 初始化执行一次校验
    //   checkAllInputValid();
    // });

    $('#bcpo .bcpo-default').each(function(){
  const $wrap = $(this);
  const $select = $wrap.find('select[name^="properties["]');
  if (!$select.length) return;

  // 防止重复创建输入框
  if ($wrap.find('.inch-input-group').length > 0) return;

  // 只取【未禁用】的option，过滤掉 "Choose one" 占位项
  const numArr = [];
  $select.find('option:not(:disabled)').each(function(){
    const v = $(this).val().trim();
    const num = Number(v);
    // 只推入有效数字
    if (v !== '' && !isNaN(num)) {
      numArr.push(num);
    }
  });

  // 没有有效数字直接退出
  if (numArr.length === 0) return;

  const min = Math.min(...numArr);
  const max = Math.max(...numArr);

  // 生成输入框，动态绑定正确min/max
  const $inputGroup = $(`
    <div class="inch-input-group">
      <input class="inch-input" type="number" min="${min}" max="${max}" value="${$select.val()}">
      <span class="inch-input-unit">inches</span>
    </div>
  `);
  $select.after($inputGroup);
  const $input = $inputGroup.find('.inch-input');

  // 全局校验所有输入框
  function checkAllInputValid() {
    let allValid = true;
    $('#bcpo .inch-input').each(function(){
      const val = $(this).val();
      const num = Number(val);
      const mi = Number($(this).attr('min'));
      const ma = Number($(this).attr('max'));
      if (isNaN(num) || num < mi || num > ma) {
        allValid = false;
      }
    });
    $('.product-form__submit').toggleClass('disabled', !allValid);
  }

  // select切换 → 更新input
  $select.on('change', function(){
    const val = $(this).val();
    $input.val(val);
    $input.removeClass('input-error');
    checkAllInputValid();
  });

  // input输入 → 匹配option
  $input.on('input', function(){
    const val = $(this).val();
    const num = Number(val);

    if (isNaN(num) || num < min || num > max) {
      $(this).addClass('input-error');
    } else {
      $(this).removeClass('input-error');
      // 找到对应value的option选中
      const $targetOpt = $select.find(`option:not(:disabled)[value="${num}"]`);
      if ($targetOpt.length) {
        $targetOpt.prop('selected', true);
      }
    }
    checkAllInputValid();
  });

  // 页面初始化校验
  checkAllInputValid();
});



    // 尺寸切换按钮点击事件
    $('#bcpo .customize-switch-wrapper .customize-switch-btn').on('click', function() {
      $(this).parent().find('.active').removeClass('active');
      $(this).addClass('active');
      
      var customizeBtn = $('.bcpo-front-button-option[value="customize" i]');
      let isSize = $(this).attr('data-customize-switch-btn') == 'size';
      
      // 控制尺寸提示 .active 类名
      if (isSize) {
        $('.tips.isCustomize').removeClass('active');
      } else {
        $('.tips.isCustomize').addClass('active');
      }
      
      customizeBtn.prop('checked', false);
      $('.single-option-selector:has(.bcpo-front-button-option[value="customize" i]) >div:not(:has([value="customize" i]))').css('display', isSize ? 'inline-block' : 'none');
      
      if (!isSize) {
        customizeBtn.click();
        $('#bcpo .bcpo-default:has(select[name^="properties["]) select').eq(0).change();
      } else {
        $('.single-option-selector:has(.bcpo-front-button-option[value="customize" i]) >div:first-of-type label').click();
      }
      
      // Size模式同步禁用输入框
      $('#bcpo [name*="width" i], #bcpo [name*="height" i]').attr('disabled', isSize);
      $('#bcpo .inch-input').prop('disabled', isSize);
    });
  }
});


// 配置观察选项（观察整个文档的子节点变化）
bcpoObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});